import { FloatingDelayGroup } from '@floating-ui/react'
import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { isEventFromOwnDom } from '../../../../utils/events'
import { EntityLabelList } from '../../../Entity'
import { EntityExtraTags } from '../../../EntityExtraTags'
import { FloatingTooltip } from '../../../Floating'
import {
  QA_NAME_REQUEST_BOARD_CARD,
  REQUEST_BOARD_CARD_TOOLTIP_HOVER_CONFIG,
} from '../RequestBoard.constants'

import { RequestBoardCardHead } from './RequestBoardCardHead'
import { RequestBoardCardLocation } from './RequestBoardCardLocation'
import { RequestBoardCardMeta } from './RequestBoardCardMeta'
import { RequestBoardCardTitle } from './RequestBoardCardTitle'

import * as styles from './RequestBoardCard.module.css'

function RequestBoardCard({
  extra,
  getActions,
  getProfileLink,
  isPending = false,
  item,
  ref,
  tooltip,
  onCallAction,
  onClick = EMPTY_FUNCTION,
  onClickDocFlowTag,
  onClickEmailTag,
  onClickFileTag,
  onClickRequestTag,
  onMouseDown = EMPTY_FUNCTION,
}) {
  const {
    assignees,
    building,
    directory_id: directoryId,
    due_date: dueDate,
    flat,
    id,
    labels,
    status,
    title,
    unread,
  } = item

  function handleClick(event) {
    if (isEventFromOwnDom(event)) {
      onClick(id, event)
    }
  }

  function handleMouseDown(event) {
    if (isEventFromOwnDom(event)) {
      onMouseDown(id, event)
    }
  }

  return (
    <FloatingDelayGroup>
      <FloatingTooltip
        content={tooltip}
        hoverConfig={REQUEST_BOARD_CARD_TOOLTIP_HOVER_CONFIG}
      >
        <div
          {...getQaSelector({ value: QA_NAME_REQUEST_BOARD_CARD })}
          className={classNames(styles.RequestBoardCard, {
            [styles.pending]: isPending,
          })}
          ref={ref}
          onClick={handleClick}
          onMouseDown={handleMouseDown}
        >
          <RequestBoardCardHead
            getActions={getActions}
            getProfileLink={getProfileLink}
            isMenuDisabled={isPending}
            item={item}
            onCallAction={onCallAction}
          />
          <RequestBoardCardTitle title={title} unread={unread} />
          <RequestBoardCardLocation building={building} flat={flat} />
          <RequestBoardCardMeta
            assignees={assignees}
            dueDate={dueDate}
            status={status}
          />
          <EntityExtraTags
            interactable
            directoryId={directoryId}
            extra={extra}
            id={id}
            onClickDocFlowTag={onClickDocFlowTag}
            onClickEmailTag={onClickEmailTag}
            onClickFileTag={onClickFileTag}
            onClickRequestTag={onClickRequestTag}
          />
          <EntityLabelList className={styles.labels} labels={labels} />
        </div>
      </FloatingTooltip>
    </FloatingDelayGroup>
  )
}

export default RequestBoardCard
